module.exports = __webpack_public_path__ + "img/partner 10.479239a5.jpg";